export default __webpack_public_path__ + "static/carbon-71287864f9c1728690addc5ade182b35.jpg";